import * as React from 'react';

import RaceProgramDailyNum from '@/components/elements/Text/RaceProgramDailyNum';
import { RaceProgram } from '@/lib/apollo/types/gen/graphql';
import { getVelodromeByCode } from '@/lib/race/velodrome';

import RaceInfoIcon from '../RaceInfoIcon';
import { Icons, VelodromeLink, VelodromeName, Wrapper } from './style';

interface RaceProgramDetailProps {
  raceProgram: RaceProgram;
  hasLink: boolean;
  href?: string; // 競輪場名を押したとき遷移先を指定する
}

const RaceProgramDetail: React.FC<RaceProgramDetailProps> = React.memo(
  ({ raceProgram, hasLink, href }) => (
    <Wrapper>
      <VelodromeName>
        {hasLink ? (
          <VelodromeLink to={href || '/'}>
            {getVelodromeByCode(raceProgram.velodromeCode).name}競輪
          </VelodromeLink>
        ) : (
          <>{getVelodromeByCode(raceProgram.velodromeCode).name}競輪</>
        )}
      </VelodromeName>
      <Icons>
        <RaceInfoIcon {...raceProgram} />
      </Icons>
      <RaceProgramDailyNum {...raceProgram} />
    </Wrapper>
  ),
);

export default RaceProgramDetail;
